import { Box, Button, Container, Typography } from '@mui/material';
import Header from './Header';
import TrustedBy from './TrustedBy';
import SentimentSection from './SentimentSection';
import UploadSection from './UploadSection';
import ConversationSection from './ConversationSection';
import FeaturesSection from './FeaturesSection';
import TestimonialSection from './TestimonialSection';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import FloatingMetricsCards from './FloatingMetricsCards';
import CTASection from './CTASection';
import CaseStudySection from './CaseStudySection';
import DemoFormModal from './DemoFormModal';
import { useState } from 'react';

const LandingPage = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const handleOpenDemoModal = () => setIsDemoModalOpen(true);
  const handleCloseDemoModal = () => setIsDemoModalOpen(false);

  return (
    <Box sx={{ 
      width: '100%',
      // maxWidth: '100vw',
      overflowX: 'hidden',
      position: 'relative',
      scrollBehavior: 'smooth',
      fontFamily: 'Gilroy, sans-serif',
      // bgcolor: '#FFFFFF', 
      // backgroundImage: `
      //   linear-gradient(to right, rgba(221, 213, 255, 0.2) 2px, transparent 2px),
      //   linear-gradient(to bottom, rgba(221, 213, 255, 0.2) 2px, transparent 2px)
      // `,
      backgroundColor: '#F7F8FA',
      backgroundSize: '60px 60px',
      backgroundPosition: 'center center',
      display:"flex",
      flexDirection:"column",
      alignItems:"center",
      justifyContent:"center"
    }}>
      <Header />
      <Container 
        maxWidth="lg" 
        // disableGutters={false}
        sx={{ 
          px: { xs: 0, sm: 3, md: 4 },
          mx: 'auto',
          position: 'relative',
          width: '100%',
          boxSizing: 'border-box',
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            pt: { xs: 8, sm: 10, md: 12 },
            pb: { xs: 2, sm: 4, md: 6 },
            position: 'relative',
            fontFamily: 'Gilroy, sans-serif',
            backgroundColor: 'transparent'
          }}
        >
          <Typography
            variant="h1"
            component="h1"
            color="primary"
            sx={{
              px:{xs: 1, md: 4},
              fontSize: { xs: '36px', md: '64px' },
              fontWeight: 600,
              lineHeight: 1.1,
            //   color: '#1A1A1A',
              maxWidth: '800px',
              position: 'relative',
              letterSpacing:-2,
              fontFamily: 'Gilroy, sans-serif'
            }}
          >
            Turn comment sections 
          </Typography>
          <Typography
            variant="h1"
            component="h1"
            color="primary"
            sx={{
              mb: 3,
              px:4,
              fontSize: { xs: '36px', md: '64px' },
              fontWeight: 600,
              lineHeight: 1.2,
            //   color: '#1A1A1A',
              maxWidth: '800px',
              position: 'relative',
              letterSpacing:-2,
              fontFamily: 'Gilroy, sans-serif'
            }}
          >
           into insights
          </Typography>
          <Typography
            sx={{
              px:2,
              fontSize: { xs: '18px', md: '20px' },
              color: '#4D4D4D',
              maxWidth: '700px',
              lineHeight: 1.3,
              fontFamily: 'Gilroy, sans-serif',
              fontWeight: 600
            }}
          >
            Siftsy is the AI-powered platform brands and agencies rely on
          to understand social media comments
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, mb: 6, mt: {xs: 3, md: 4} }}>
            {/* <Button
              variant="contained"
              sx={{
                bgcolor: '#4728c4',
                color: 'white',
                px: 4,
                py: 1.75,
                fontSize: '16px',
                fontWeight: 600,
                '&:hover': {
                  bgcolor: '#3B20A3',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(71, 40, 196, 0.25)',
                },
                transition: 'all 0.2s ease-in-out',
                borderRadius: '8px',
                textTransform: 'none',
              }}
            >
              Try for Free
            </Button> */}
            <Button
              variant="contained"
              onClick={handleOpenDemoModal}
              sx={{ 
                bgcolor: '#4728c4',
                color: 'white',
                px: 4,
                py: 1.75,
                borderRadius: 12,
                fontSize: '16px',
                fontWeight: 600,
                '&:hover': {
                  bgcolor: '#3B20A3',
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s ease-in-out',
                borderRadius: '12px',
                textTransform: 'none',
              }}
            >
              Request a Demo
            </Button>
          </Box>

          <Box>
            <Typography
              sx={{
                color: '#333',
                fontSize: '16px',
                mb: 3,
                px: 6,
                fontFamily: 'Gilroy, sans-serif',
                fontWeight: 600
              }}
            >
              Trusted by top brands and agencies around the world
            </Typography>
            <TrustedBy />
          </Box>
          {/* <FloatingMetricsCards /> */}
        </Box>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          height: {xs: 500, sm: 400, md:550, lg:700},
          overflow: 'hidden',
        }}>
                <Box sx={{
                  overflow: "hidden",
                  animation: 'popUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards',
                  animationDelay: '.5s',
                  opacity: 0,
                  position:"absolute",  
                  top: 0,
                  left: {xs: "-5%", sm: 0, md: 0},
                  width:{xs: "110%", sm: "100%", md: "100%"},
                  transform: {xs: 'scale(0.95)', sm: 'scale(1)', md: 'scale(1)'},
                  '@keyframes popUp': {
                    '0%': {
                      opacity: 0,
                      transform: 'translateY(40px) scale(0.95)'
                    },
                    '100%': {
                      opacity: 1,
                      transform: {xs: 'translateY(0) scale(0.95)', sm: 'translateY(0) scale(1)', md: 'translateY(0) scale(1)'}
                    }
                  }
                }}>
                <img 
  src="/hero-comments.png" 
  alt="Siftsy Comments"
  style={{
    width: '100%',
    height: 'auto',
    maxWidth: '100%',
    display: 'block',
    imageRendering: '-webkit-optimize-contrast',
  }}
/>
                </Box>
                <Box sx={{
  position: 'absolute',
  top: {xs: 40, sm: 40, md: 40},
  left: {xs: "-10%", sm: 0, md: 0},
  animation: 'popUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards',
  animationDelay: '1s',
  opacity: 0,
  width: {xs: "120%", sm: "100%", md: "100%"}, // Slightly wider on mobile
  margin: "0 auto",
  // Add will-change for better animation performance
  willChange: 'transform, opacity',
  '@keyframes popUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(40px) scale(0.98)' // Slight scale for mobile
    },
    '100%': {
      opacity: 1,
      transform: {xs: 'translateY(0) scale(1)', sm: 'translateY(0) scale(1)', md: 'translateY(0) scale(1)'}
    }
  }
}}>

<img 
  src="/hero-panel.png" 
  alt="Siftsy Hero Panel"
  style={{
    // width: {xs: '130%', sm: '100%', md: '100%'},
    height: 'auto',
    width: '100%',
    display: 'block',
    imageRendering: '-webkit-optimize-contrast',
  }}
/>
                </Box>  
        </Box>
           

      </Container>
      
      <SentimentSection />
      <ConversationSection />
      <UploadSection />

      <FeaturesSection />


      {/* Teams Section */}
      <Box sx={{ 
        py: { xs: 8, md: 12 }, 
        px: { xs: 2, md: 4 },
        bgcolor: '#fff',
        borderRadius: 6,
        boxShadow: '0 4px 20px rgba(71, 40, 196, 0.08)',
      }}>
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 3, md: 4 } }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '24px', sm: '32px', md: '40px', lg: '40px' },
                textAlign: 'center',
                mb: { xs: 4, sm: 4, md: 4 },
                fontFamily: 'Gilroy, sans-serif',
                letterSpacing: { xs: -1, md: -1.8 },
                color: '#4728c4',
             
              }}
            >
              Siftsy empowers teams across the social media ecosystem
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '16px', md: '20px' },
                color: '#4D4D4D',
                maxWidth: '600px',
                mx: 'auto',
                fontFamily: 'Gilroy, sans-serif',
                fontWeight: 500
              }}
            >
              From influencer marketing to social intelligence, Siftsy provides crucial insights from the comments.
            </Typography>
          </Box>

          <Box sx={{ 
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
            gap: {xs: 2, md: 4},
            mb: 4
          }}>
            {[
              {
                title: 'Influencer Marketing',
                description: 'Analyze comments from 100s of influencer posts cross-platform.'
              },
              {
                title: 'Social Media Management',
                description: 'Understand what people are saying on your channels.'
              },
              {
                title: 'Social Listening',
                description: 'Dive deeper into what people are saying online.'
              },
              {
                title: 'Market Research',
                description: 'Leverage comment sections as live focus groups.'
              },
              {
                title: 'Community Management',
                description: 'Get low and high level views of how your community is interacting.'
              },  
              {
                title: 'Brand & PR',
                description: 'Capture granular insight into how people think about public brands.'
              }
            ].map((team, index) => (
              <Box
                key={index}
                sx={{
                  bgcolor: 'white',
                  p: 4,
                  borderRadius: '16px',
                  boxShadow: '0 4px 20px rgba(71, 40, 196, 0.08)',
                  border: '1px solid rgba(71, 40, 196, 0.1)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(71, 40, 196, 0.15)',
                    borderColor: '#4728c4'
                  }
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#4728c4',
                    mb: 2,
                    fontFamily: 'Gilroy, sans-serif'
                  }}
                >
                  {team.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '16px',
                    color: '#4D4D4D',
                    lineHeight: 1.6,
                    fontFamily: 'Gilroy, sans-serif',
                    fontWeight: 500
                  }}
                >
                  {team.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>

      {/* <CaseStudySection /> */}
      <TestimonialSection />
      <CTASection />
      <Footer />
      <ScrollToTop />
      <DemoFormModal open={isDemoModalOpen} onClose={handleCloseDemoModal} />
    </Box>
  );
};

export default LandingPage; 